<div class="usage-limit-input">
  <div>
    <label [attr.aria-hidden]="true" id="scan-default-timeout-hours-label" class="label mb-1 text-nowrap">
      {{ 'scan_default_timeout_label' | translate }}
    </label>
    <button class="btn margin-left-sm" [appTooltip]="'scan_default_timeout_tooltip' | translate">
      <svg class="open-icon margin-bottom-xs" width="1rem" height="1rem" aria-hidden="true">
        <use xlink:href="#question-mark-2"></use>
      </svg>
      <span class="visually-hidden">{{ 'scan_default_timeout_tooltip' | translate }}</span>
    </button>
  </div>
  <div class="row">
    <div class="end-align">
      <input
        type="number"
        [attr.min]="minScanTimeoutHours"
        [attr.max]="maxScanTimeoutHours"
        id="scan-default-timeout-hours"
        data-test-id="scan-default-timeout-hours"
        class="form-element included-amount"
        [ngStyle]="{ width: '6rem !important' }"
        [name]="fieldName"
        [formControl]="$any(form.get(fieldName))"
        [attr.aria-label]="'scan_default_timeout_label' | translate"
        aria-describedby="scan-default-timeout-hours_error"
        [attr.aria-invalid]="form | fieldInvalid: fieldName"
        [placeholder]="legacyScanTimeoutHours"
      />
      <div id="scan-default-timeout-hours_maxAmountLabel" class="bottom-label">
        {{ 'max' | translate }} {{ maxScanTimeoutHours }}{{ 'h' | translate }}
      </div>
    </div>
  </div>
  <div id="scan-default-timeout-hours_error" class="error-container">
    <app-form-field-error
      [formValidationRequest$]="formValidationRequest$"
      [field]="form.get(fieldName)"
      [name]="fieldName"
      [label]="'scan_default_timeout_label'"
    ></app-form-field-error>
  </div>
  @if (showOutpostVersionWarning) {
    <div id="scan-default-timeout-outpost-version-warning" class="alert alert-warning mt-2" role="alert">
      <div class="row align-items-center">
        <div class="col-auto">
          <svg class="warning-symbol" aria-hidden="true" focusable="false">
            <use xlink:href="#exclamation-triangle"></use>
          </svg>
          <span class="ms-2 text-black">{{ 'scan_default_timeout_outdated_agent_warning' | translate }}</span>
        </div>
      </div>
    </div>
  }
</div>
